import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/service/auth.service';
import { User } from 'src/app/model/user.model';
import { Router } from '@angular/router';
import { Role } from 'src/app/model/role.model';
import { TranslationService } from 'src/app/service/translate.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {
  appTitle = 'Snow Stars Team';
  currentUser: User;
  langImage: '../../../assets/images/en.png';

  @Output() public sidenavToggle = new EventEmitter();

  constructor(
    private authService: AuthService,
    private router: Router,
    public translationService: TranslationService) {
    this.authService.currentUser.subscribe(x => (this.currentUser = x));
  }

  ngOnInit() {}

  onLogout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  onToggleSidenav() {
    this.sidenavToggle.emit();
  }

  changeLang() {
    this.translationService.changeLang();
  }

  get isAdmin() {
    return this.currentUser && this.currentUser.role === Role.Admin;
  }

  get isUser() {
    return this.currentUser && this.currentUser.role === Role.User;
  }

  get isInstructor() {
    return this.currentUser && this.currentUser.role === Role.Instructor;
  }
}
